<template>
  <div>
    <el-upload :ref="refName || 'file'" action="https://up-z2.qiniup.com" :accept="accept" :multiple="multiple"
      :show-file-list="nolist ? false : true" class="uploader" :list-type="accept == 'video/*' ? 'text' : 'picture'"
      :file-list="fileList" :limit="multiple ? (limit || 9) : 1" :before-upload="beforeUpload" :on-exceed="handleExceed"
      :on-remove="removeHandle" :auto-upload="true">
      <el-button slot="trigger" size="small" :type="accept == 'video/*' ? 'danger' : 'primary'">{{ title ||
        "选择文件"
      }}</el-button>
    </el-upload>
  </div>
</template>

<script>
var random = require('string-random');
import moment from "moment";
import axios from "axios";
import * as qiniu from 'qiniu-js';

export default {
  props: {
    filePrevUrl: String,
    worksite: String,
    refName: String,
    title: String,
    accept: String,
    field: String,
    list: Array,
    multiple: Boolean,
    limit: Number,
    nolist: Boolean,
    // 可选：覆盖后台瘦身默认参数（如轮播图需要 { maxEdge: 1125, trim: 0 }），
    // 不传则走 slimOnly 默认值（maxEdge=800、trim=1），横幅大图会被压糊/裁变形
    slimParams: Object
  },
  watch: {
    list: {
      handler(val) {
        this.fileList = val || [];
      },
      immediate: true // 首次加载触发
    },
    worksite: {
      handler() {
        // worksite 变化时重置 tokenReady，让后续 beforeUpload 等新的 token
        this.qiniuToken = null;
        this.tokenReady = new Promise((resolve) => { this._resolveToken = resolve; });
        this.getToken();
      },
      immediate: true // 首次加载触发
    }
  },
  data() {
    return {
      qiniuToken: null,
      // 私有 worksite 用其自有 prevUrl 回显；prop.filePrevUrl 来自父组件，组件内改 prop 不生效，
      // 所以缓存到 data 自己的字段。
      localPrevUrl: null,
      defaultFilePrevUrl: "https://cdn.aixyt.com/",
      fileList: this.list || [],
      // 异步 token 解析 Promise，便于 beforeUpload 等待
      tokenReady: null
    };
  },
  created() {
    this.tokenReady = new Promise((resolve) => { this._resolveToken = resolve; });
  },
  methods: {
    getToken() {
      // "NULL" 或空 → 走公共 bucket（config.qiniuDomain）；否则走私有 worksite
      var wid = (this.worksite && this.worksite !== "NULL") ? this.worksite : "NULL";
      axios.get("live/file/qiniuAccessTokenAndPrevUrl/" + wid).then(res => {
        var d = res.data;
        if (d && d.success) {
          this.qiniuToken = d.data.token;
          // 私有 worksite 用其自有域名回显，否则用公共域名
          this.localPrevUrl = d.data.prevUrl || this.defaultFilePrevUrl;
          this._resolveToken && this._resolveToken();
        } else {
          this.qiniuToken = d;
          // 失败也放行，避免 beforeUpload 永远等
          this._resolveToken && this._resolveToken();
        }
      }).catch(() => {
        this.$message.error("获取上传凭证失败");
        this._resolveToken && this._resolveToken();
      });
    },
    refreshToken() {
      var wid = (this.worksite && this.worksite !== "NULL") ? this.worksite : "NULL";
      axios.get("live/file/qiniuAccessTokenAndPrevUrl/" + wid).then(res => {
        var d = res.data;
        if (d && d.success) {
          this.qiniuToken = d.data.token;
          this.localPrevUrl = d.data.prevUrl || this.defaultFilePrevUrl;
        } else {
          this.qiniuToken = d;
        }
      }).catch(() => {
        this.$message.error("刷新上传凭证失败");
      });
    },
    handleExceed(files, fileList) {
      this.$message.error(`当前限制选择 ${this.limit || 1} 个文件，已存在${fileList.length}个文件，本次选择了 ${files.length} 个文件`);
    },
    // base64 → Blob
    _b64toBlob(b64, type) {
      var byteStr = atob(b64);
      var len = byteStr.length;
      var ab = new ArrayBuffer(len);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < len; i++) {
        ia[i] = byteStr.charCodeAt(i);
      }
      return new Blob([ab], { type: type || "image/webp" });
    },
    // 把瘦身后的主图包装成带后缀名的 File，便于七牛直传与回显
    _slimResultToFile(main, format, originName) {
      var blob = this._b64toBlob(main.base64, "image/" + format);
      var ext = "." + (format === "jpeg" ? "jpg" : format);
      var baseName = (originName || "image").replace(/\.[^.]+$/, "");
      return new File([blob], baseName + ext, { type: "image/" + format });
    },
    // 原图先发后台瘦身，再返回瘦身后的 File（动图走原图）
    slimBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        var fd = new FormData();
        fd.append("file", file);
        // 父组件可通过 slimParams 覆盖默认瘦身参数（maxEdge/quality/limit/trim 等）
        var sp = this.slimParams || {};
        Object.keys(sp).forEach(k => {
          if (sp[k] !== undefined && sp[k] !== null) fd.append(k, sp[k]);
        });
        axios.post("live/imageLib/slimOnly", fd, {
          headers: { "Content-Type": "multipart/form-data" }
        }).then(res => {
          var d = res.data;
          if (d && d.success && !d.skipped && d.main && d.main.base64) {
            var slimFile = this._slimResultToFile(d.main, d.format, file.name);
            resolve(slimFile);
          } else {
            // 瘦身失败或动图：原样直传，不让上传卡死
            resolve(file);
          }
        }).catch(() => {
          // 后台瘦身异常：降级为原图直传，保证可用性
          resolve(file);
        });
      });
    },
    beforeUpload(file) {
      let fileName = file.name;
      let ext = fileName.substring(fileName.lastIndexOf("."));
      var putExtra = {
        fname: file.name
      }
      var config = {
        region: qiniu.region.z2
      }

      // 等待 token 就绪（首次进入页面时父组件可能传 worksite 后 getToken 还没回来），
      // 同时先走后台统一瘦身：原图 → 后台 slim → 瘦身后的文件再直传七牛。
      var doUpload = (fileToUpload) => {
        var key = moment().format("YYYYMMDD/") + random(32) + ext;
        var observable = qiniu.upload(fileToUpload, key, this.qiniuToken, putExtra, config);
        observable.subscribe({
          next(res) {
            // 可以在这里添加上传进度条更新的代码
          },
          error: (err) => {
            if (err.name == "InvalidToken" || err.code == 401) {
              this.refreshToken();
              this.$message.error("上传失败,请重新上传");
            } else {
              this.$message.error(err.message);
            }
          },
          complete: (res) => {
            this.uploadSuccess({
              fileName,
              result: res
            });
          },
        });
      };

      var run = (theFile) => {
        if (this.qiniuToken) {
          doUpload(theFile);
        } else if (this.tokenReady) {
          this.tokenReady.then(() => doUpload(theFile));
        } else {
          doUpload(theFile);
        }
      };

      // 统一走后台瘦身逻辑
      this.slimBeforeUpload(file).then(slimFile => {
        ext = slimFile.name.substring(slimFile.name.lastIndexOf("."));
        run(slimFile);
      });

      return false; // 阻止 el-upload 默认上传行为
    },
    uploadSuccess(res) {
      // 优先用接口返回的 prevUrl（私有 worksite 自有域名），否则父组件 prop，再否则公共默认
      let fileUrl = (this.localPrevUrl || this.filePrevUrl || this.defaultFilePrevUrl) + res.result.key;
      // 图片上传成功，得到图片地址，告知父页面
      if (this.nolist) {
        this.fileList = [];
      } else if (!this.multiple || this.limit == 1) {
        this.fileList = [{
          name: res.fileName,
          url: fileUrl
        }];
      } else {
        this.fileList.push({
          name: res.fileName,
          url: fileUrl
        });
      }
      this.$emit("file", {
        field: this.field,
        url: fileUrl
      });
    },
    removeHandle(file) {
      this.$emit("remove", file.url);
    },
    clearAllFiles() {
      this.fileList = [];
    }
  }
};

</script>


// WEBPACK FOOTER //
// src/components/upload.vue